/**
 * PortalButton.tsx
 * ────────────────────────────────────────────────────────────────
 * "Return to your working portal" affordance for admins + teachers
 * who flip into the student-facing app for QA / content review /
 * showing students how something looks.
 *
 *   admin  → label "Portal do Administrador" → /admin
 *   teacher → label "Portal do Professor"   → /teacher
 *   student → renders nothing (no-op)
 *
 * Mirrors the "← App" link on /admin and /teacher dashboards so the
 * round-trip is one click in either direction. Drop into any
 * student-facing page header where the admin/teacher might land.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export const PortalButton: React.FC = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  if (!user) return null
  const isAdmin   = user.is_admin || user.role === 'admin'
  const isTeacher = user.role === 'teacher'
  if (!isAdmin && !isTeacher) return null
  const label  = isAdmin ? 'Portal do Administrador' : 'Portal do Professor'
  const target = isAdmin ? '/admin' : '/teacher'
  return (
    <button
      onClick={() => navigate(target)}
      className="text-xs font-semibold text-white bg-indigo-600 hover:bg-indigo-700 px-2.5 py-1 rounded-lg transition-colors whitespace-nowrap"
      title={`Voltar para o ${label.toLowerCase()}`}
    >
      {label}
    </button>
  )
}
